import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, unref as _unref } from "vue"

const _hoisted_1 = { class: "font-weight-bold" }
const _hoisted_2 = {
  key: 0,
  class: "text-body-2"
}
const _hoisted_3 = { class: "text-caption mt-1" }
const _hoisted_4 = { class: "font-weight-bold" }
const _hoisted_5 = { class: "font-weight-bold" }

import {computed, onMounted, ref} from 'vue'
import {useGlobalSetting} from '@/lib/utils'
import {getUserList} from "@/types/Order";
import {supabase} from "@/api";
import UserSelect from "@/components/inputs/UserSelect.vue";
import OrderSelect from "@/components/inputs/OrderSelect.vue";
import OutageSelect from "@/components/inputs/OutageSelect.vue";

interface ChecklistTemplate {
  id?: number
  title: string
  description: string
  work_group: string | null
  items: { label: string }[]
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ChecklistAssignForm',
  props: {
    template: {},
    checklistId: {},
    checklistTitle: {},
    initialAssignees: {},
    initialAssetId: {},
    initialOrderId: {},
    initialOutageCode: {},
    initialScheduledStart: {},
    initialScheduledEnd: {}
  },
  emits: ["assign", "cancel", "saved"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const editMode = computed(() => !!props.checklistId)

const emit = __emit

const userOptions = ref<any[]>([])
const saving = ref(false)

const form = ref({
  assignees: [] as string[],
  assetId: '',
  orderId: null as number | null,
  outage_code: null as number | null,
  scheduledStart: '',
  scheduledEnd: ''
})

function assign() {
  if (!props.template?.id || form.value.assignees.length === 0) return

  emit('assign', {
    templateId: props.template.id,
    assignees: form.value.assignees,
    scheduledStart: form.value.scheduledStart || null,
    scheduledEnd: form.value.scheduledEnd || null,
    assetId: form.value.assetId || null,
    orderId: form.value.orderId || null,
    outage_code: form.value.outage_code || null
  })
}

async function saveEdit() {
  if (!props.checklistId || form.value.assignees.length === 0) return
  saving.value = true

  const {error} = await supabase
      .from('checklists')
      .update({
        assignees: form.value.assignees,
        asset_id: form.value.assetId?.trim() || null,
        order_id: form.value.orderId && !isNaN(form.value.orderId) ? form.value.orderId : null,
        scheduled_start: form.value.scheduledStart || null,
        scheduled_end: form.value.scheduledEnd || null
      })
      .eq('id', props.checklistId)

  saving.value = false

  if (error) {
    console.error('Checklist update failed:', error)
    return
  }

  emit('saved')
  emit('cancel')
}

onMounted(async () => {
  userOptions.value = await getUserList()

  if (editMode.value) {
    // Edit-Modus: vorhandene Daten vorausfüllen
    form.value = {
      assignees: props.initialAssignees ? [...props.initialAssignees] : [],
      assetId: props.initialAssetId || '',
      orderId: props.initialOrderId ?? null,
      outage_code: props.initialOutageCode ?? null,
      scheduledStart: props.initialScheduledStart || '',
      scheduledEnd: props.initialScheduledEnd || ''
    }
  } else {
    form.value = {
      assignees: [],
      assetId: '',
      orderId: null,
      outage_code: null,
      scheduledStart: '',
      scheduledEnd: ''
    }
  }
})

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_expand_transition = _resolveComponent("v-expand-transition")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, { rounded: "lg" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_toolbar, {
        color: "primary",
        density: "compact"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, {
            icon: editMode.value ? 'mdi-pencil-outline' : 'mdi-send-outline',
            class: "ms-4 me-2"
          }, null, 8, ["icon"]),
          _createVNode(_component_v_toolbar_title, { class: "text-subtitle-1 font-weight-medium" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(editMode.value ? 'Checkliste bearbeiten' : 'Checkliste zuweisen'), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_card_text, { class: "pa-4 pa-md-6" }, {
        default: _withCtx(() => [
          (!editMode.value)
            ? (_openBlock(), _createBlock(_component_v_alert, {
                key: 0,
                variant: "tonal",
                density: "compact",
                class: "mb-5",
                type: "info"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.template?.title), 1),
                  (_ctx.template?.description)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.template.description), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.template?.items?.length || 0) + " Prüfpunkte", 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (editMode.value)
            ? (_openBlock(), _createBlock(_component_v_alert, {
                key: 1,
                variant: "tonal",
                density: "compact",
                class: "mb-5",
                type: "info"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, "#" + _toDisplayString(_ctx.checklistId) + " — " + _toDisplayString(_ctx.checklistTitle), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(UserSelect, {
            modelValue: form.value.assignees,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.assignees) = $event)),
            label: "Zuweisen an",
            multiple: "",
            rounded: "lg",
            "prepend-inner-icon": "mdi-account-multiple"
          }, null, 8, ["modelValue"]),
          _createVNode(_component_v_text_field, {
            modelValue: form.value.assetId,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.assetId) = $event)),
            label: "Anlage / AKZ (optional)",
            variant: _unref(useGlobalSetting)().globalTextVariant,
            rounded: "lg",
            "prepend-inner-icon": "mdi-factory",
            clearable: ""
          }, null, 8, ["modelValue", "variant"]),
          _createVNode(OrderSelect, {
            modelValue: form.value.orderId,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.orderId) = $event)),
            label: "Auftrag (optional)",
            rounded: "lg",
            "prepend-inner-icon": "mdi-clipboard-text",
            clearable: "",
            class: "mb-6"
          }, null, 8, ["modelValue"]),
          _createVNode(OutageSelect, {
            modelValue: form.value.outage_code,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.outage_code) = $event)),
            label: "Stillstand (optional)",
            rounded: "lg",
            "prepend-inner-icon": "mdi-power",
            clearable: "",
            class: "mb-6"
          }, null, 8, ["modelValue"]),
          _createVNode(_component_v_row, { class: "mb-1" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "12",
                sm: "6"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    modelValue: form.value.scheduledStart,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.scheduledStart) = $event)),
                    label: "Start",
                    variant: _unref(useGlobalSetting)().globalTextVariant,
                    rounded: "lg",
                    type: "datetime-local",
                    "prepend-inner-icon": "mdi-calendar-start"
                  }, null, 8, ["modelValue", "variant"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "12",
                sm: "6"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    modelValue: form.value.scheduledEnd,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.value.scheduledEnd) = $event)),
                    label: "Ende",
                    variant: _unref(useGlobalSetting)().globalTextVariant,
                    rounded: "lg",
                    type: "datetime-local",
                    "prepend-inner-icon": "mdi-calendar-end"
                  }, null, 8, ["modelValue", "variant"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_expand_transition, null, {
            default: _withCtx(() => [
              (form.value.assignees.length > 0 && !editMode.value)
                ? (_openBlock(), _createBlock(_component_v_alert, {
                    key: 0,
                    variant: "tonal",
                    type: "success",
                    density: "compact",
                    class: "mt-2"
                  }, {
                    default: _withCtx(() => [
                      _cache[8] || (_cache[8] = _createTextVNode(" 1 Checkliste wird erstellt für: ")),
                      _createElementVNode("span", _hoisted_5, _toDisplayString(form.value.assignees.join(', ')), 1)
                    ]),
                    _: 1,
                    __: [8]
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_divider),
      _createVNode(_component_v_card_actions, { class: "pa-4" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_btn, {
            variant: "text",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('cancel')))
          }, {
            default: _withCtx(() => _cache[9] || (_cache[9] = [
              _createTextVNode("Abbrechen")
            ])),
            _: 1,
            __: [9]
          }),
          _createVNode(_component_v_spacer),
          _createVNode(_component_v_btn, {
            color: "primary",
            variant: "flat",
            rounded: "lg",
            "prepend-icon": editMode.value ? 'mdi-content-save' : 'mdi-send',
            disabled: form.value.assignees.length === 0 || (editMode.value && saving.value),
            loading: editMode.value && saving.value,
            onClick: _cache[7] || (_cache[7] = ($event: any) => (editMode.value ? saveEdit() : assign()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(editMode.value ? 'Speichern' : 'Zuweisen'), 1)
            ]),
            _: 1
          }, 8, ["prepend-icon", "disabled", "loading"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})